import { getPagePath } from '@spotahome/bff/client';

import {
  getWindowTitle,
  getWindowPathname,
  getWindowHash,
  getWindowSearch,
  replaceWindowState
} from '@utils/windowHelper';
import {
  filterBelongsToPath,
  generatePathForFilter,
  generateQueryForFilter,
  shouldAvoidParamInTheUrl
} from '@utils/search-url-generator';

const AdUrlService = function AdUrlService() {};

AdUrlService.prototype.getMoveDatesAsQueryParams = function getUrlWithMoveDatesFn(
  moveIn = '',
  moveOut = ''
) {
  const getParams = [];

  if (moveIn !== '') {
    getParams.push(`move-in=${moveIn}`);
  }

  if (moveOut !== '') {
    getParams.push(`move-out=${moveOut}`);
  }

  let result = '';

  if (getParams.length > 0) {
    result = `?${getParams.join('&')}`;
  }

  return result;
};

AdUrlService.prototype.queryStringToJSON = function queryStringToJSON(str) {
  const pairs = str.split('&');
  const result = {};
  pairs.forEach(pair => {
    const [name, value] = pair.split('=');
    if (name.length) {
      if (name.indexOf('[]') > -1) {
        if (result[name] === undefined) {
          result[name] = [];
        }

        result[name].push(value || '');
      } else {
        result[name] = value || '';
      }
    }
  });

  return result;
};

// TODO: fix window
AdUrlService.prototype.getQueryStringFromUrl = function getQueryStringFromUrl() {
  const pattern = new RegExp('\\?(.+=.+)', 'i');

  const matches = pattern.exec(getWindowSearch());

  /**
   * no query string set
   */
  if (matches === null) {
    return '';
  }

  return matches[1];
};

AdUrlService.prototype.getUrlParts = function getUrlParts(urlState = {}) {
  return Object.keys(urlState)
    .filter(urlKey => urlState[urlKey])
    .map(urlKey => `${urlKey}=${urlState[urlKey]}`);
};

AdUrlService.prototype.getLocationUrlWithNewUrlState = function getLocationUrlWithNewUrlState(
  urlState
) {
  const urlParts = this.getUrlParts(urlState);

  let url = '';

  if (urlParts.length === 0) {
    url = getWindowPathname() + getWindowHash();
  } else {
    url = `${getWindowPathname()}?${urlParts.join('&')}${getWindowHash()}`;
  }

  return url;
};

AdUrlService.prototype.setLocationUrl = function setLocationUrl(urlState) {
  const url = this.getLocationUrlWithNewUrlState(urlState);

  replaceWindowState(urlState, getWindowTitle(), url);
};

AdUrlService.prototype.createTranslatedQueryString = function createTranslatedQueryString(
  filters = {}
) {
  const urlInParts = [];
  const urlTranslated = [];
  const returnQueryString = {};

  Object.keys(filters).forEach(key => {
    const simplifiedKey = key.replace(/[\[\]']+/g, '');

    if (shouldAvoidParamInTheUrl(simplifiedKey, filters[simplifiedKey])) {
      return;
    }

    if (filterBelongsToPath(simplifiedKey)) {
      const urlParam = generatePathForFilter(simplifiedKey, filters[key]);
      if (urlParam) {
        urlTranslated.push(urlParam);
      }
    } else {
      const urlQuery = generateQueryForFilter(key, filters[key]);
      if (urlQuery) {
        urlInParts.push(urlQuery);
      }
    }
  });

  if (urlTranslated.length) {
    returnQueryString.params = urlTranslated.join('/');
  }
  if (urlInParts.length) {
    returnQueryString.queryString = urlInParts.join('&');
  }

  return returnQueryString;
};

AdUrlService.prototype.createQueryString = function createQueryString(filters) {
  return Object.keys(filters)
    .map(key => generateQueryForFilter(key, filters[key]))
    .filter(Boolean)
    .join('&');
};

AdUrlService.prototype.getSearchUrlFromFilters = function getSearchUrlFromFilters(
  areaSlug,
  filters
) {
  const query = this.createTranslatedQueryString(filters);
  return this.getSearchUrl(areaSlug, query);
};

AdUrlService.prototype.getSearchUrl = function getSearchUrl(areaSlug, query) {
  let url = getPagePath('marketplace.search.deprecated', { params: { city: areaSlug } });
  url += query.params ? `/${query.params}` : '';
  url += query.queryString ? `?${query.queryString}` : '';

  return url;
};

AdUrlService.prototype.setSearchLocationUrl = function setSearchLocationUrl(
  areaSlug,
  filters
) {
  if (typeof window !== 'undefined') {
    const queryString = this.createTranslatedQueryString(filters);
    const url = this.getSearchUrl(areaSlug, queryString);

    replaceWindowState({ queryString }, getWindowTitle(), url);
  }
};

export default new AdUrlService();
